import React from 'react'
import classes from './Details.module.sass'
import { SaleItemInterface } from '../../../../../common/types/interfaces'
import { useSelector } from 'react-redux'
import { selectClusterImageUrl } from '../../../../../store/slices/currentClusterSlice'
import { SaleItemAttributes } from '../../../../../common/components/saleItemAttributes/SaleItemAttributes'

type Props = {
  el?: SaleItemInterface
}

export const Details = ({ el }: Props) => {
  const imageUrl = useSelector(selectClusterImageUrl)

  const renderFile = (path: string) => {
    const fullUrl = `${imageUrl}${path}`

    if (path.includes('video_')) {
      return (
        <video
          className={classes.video}
          src={fullUrl}
          controls
          muted
          playsInline
          poster={
            el?.files.find((p) => p.includes('poster_'))
              ? `${imageUrl}${el.files.find((p) => p.includes('poster_'))}`
              : undefined
          }
        />
      )
    }

    if (path.includes('poster_')) {
      return null // постер используется как poster для видео, не показываем отдельно
    }

    return <img className={classes.image} src={fullUrl} alt={el?.name} />
  }

  if (el)
    return (
      <div className={classes.container}>
        <div className={classes.title}>детали товара</div>
        {el.category && <div className={classes.category}>{el.category.name}</div>}
        <div className={classes.name}>{el.name}</div>
        <div className={classes.description}>{el.description}</div>
        <div className={classes.settings}>
          <div className={el.isActive ? classes.settingsItem : classes.settingsItemInActive}>
            {el.isActive ? 'Активен' : 'Не активен'}
          </div>
          <div className={el.useStock ? classes.settingsItem : classes.settingsItemInActive}>
            {el.useStock ? 'Учет остатков' : 'Нет учета остатков'}
          </div>
          <div className={el.prices[0] ? classes.settingsItem : classes.settingsItemInActive}>
            {el.prices[0] ? 'Есть цена' : 'Нет цены'}
          </div>
        </div>

        <SaleItemAttributes view attributes={el.attributes} />

        <div className={classes.images}>{el.files.map((path) => renderFile(path))}</div>
      </div>
    )
}
